import { render, staticRenderFns } from "./ConfigurableSettingsView.vue?vue&type=template&id=5a5651a2&lang=pug&"
import script from "./ConfigurableSettingsView.vue?vue&type=script&lang=js&"
export * from "./ConfigurableSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports